import styled, { spacing } from "@rentiohq/web-theme";

/**
 * The shape the status pills in the property header share.
 *
 * One layout for all of them: the state icon first, the text, and the pencil
 * last for a pill you can click to change the thing it describes. They used
 * to differ, with one wearing its pencil on the left, which read as two
 * unrelated controls sitting next to each other (Jonas, 2026-10-06).
 *
 * Only the shape lives here. What a pill is colored, and whether it is a
 * button or a div, stays with the pill: those say what it is, and a shared
 * file deciding that for both would be the drift this is meant to prevent.
 */
export const PillBase = `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 100px;
  padding: 4px ${spacing("tight")};
  line-height: 1;
`;

/** Keeps the pencil from growing with the text it follows. */
export const PillEditIcon = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
`;
